import './RenameItemModal.scss';
import {Button, Form, Input, Modal, Spin, notification} from 'antd';
import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';

const RenameItemModal = (props) => {
    const [isSubmitDisabled, setSubmitDisabled] = useState(true);
    const {form} = props;

    const {
        isRenameModalOpen,
        setIsRenameModalOpen,
        isRenameLoading,
        setIsRenameLoading,
        itemToRename,
        handleRenameSubmit,
    } = props;

    const {getFieldDecorator, validateFields, setFieldsValue} = form;
    const {t} = useTranslation();

    // 🧩 Al abrir el modal, precarga el nombre en el campo
    useEffect(() => {
        if (itemToRename && itemToRename.name) {
            setFieldsValue({ rename: itemToRename.name });
            setSubmitDisabled(false);
        }

        // Foco automático al abrir
        const timeout = setTimeout(() => {
            const elems = document.getElementsByClassName('rename-name-input');
            if (elems.length > 0) elems[0].focus();
        }, 100);

        return () => clearTimeout(timeout);
    }, [itemToRename, setFieldsValue]);

    // 🧠 Validar formulario y activar botón
    const handleValidateInput = () => {
        validateFields(['rename'], (errors) => {
            setSubmitDisabled(!!errors);
        });
    };

    // 🚀 Submit final
    const handleSubmit = async () => {
        validateFields(async (err, values) => {
            if (!err) {
                const oldName = itemToRename.name;
                const oldExt = itemToRename.isDirectory ? '' : oldName.split('.').pop();
                const newExt = itemToRename.isDirectory ? '' : values.rename.split('.').pop();


                // 📦 Si es archivo y la extensión cambió
                if (!itemToRename.isDirectory && oldExt !== newExt) {
                    Modal.confirm({
                        title: t('messages.aml.file.manager.rename.extension.changed.title') || 'Cambio de extensión detectado',
                        content:t('messages.aml.file.manager.rename.extension.changed.confirm'),
                        okText: t('messages.aml.confirm'),
                        cancelText: t('messages.aml.cancel'),
                        onOk: async () => {
                            await handleRenameConfirm(values.rename);
                        },
                    });
                } else {
                    await handleRenameConfirm(values.rename);
                }
            }
        });
    };

// 🚀 Lógica común para ejecutar el renombrado real
    const handleRenameConfirm = async (newName) => {
        setIsRenameLoading(true);
        await handleRenameSubmit(newName);
        setIsRenameLoading(false);
        setIsRenameModalOpen(false);
    };


    return (
        <div className="rename-item-modal">
            {isRenameModalOpen && (
                <Modal
                    className="folder-modal"
                    title={
                        itemToRename?.isDirectory
                            ? `${t('messages.aml.file.manager.rename.item.message')} ${t('messages.aml.folder')}`
                            : `${t('messages.aml.file.manager.rename.item.message')} ${t('messages.aml.file')}`
                    }
                    visible={true}
                    footer={null}
                    onCancel={() => setIsRenameModalOpen(false)}
                >
                    <Spin size="large" spinning={isRenameLoading}>
                        <Form id="rename-item-name" autoComplete="off">
                            <div className="folder-input-container">
                                <span className="folder-name-input" style={{fontSize: '11px'}}>
                                    {t('messages.aml.file.manager.remember.valid.character')}
                                    <span className="caracter-especial">
                                      {itemToRename?.isDirectory? "\\ % . ' \" : < > ? /" :  "\\ % ' \" : < > ? /"}
                                    </span>
                                </span>
                            </div>

                            <br />

                            <Form.Item>
                                {getFieldDecorator('rename', {
                                    rules: [
                                        {
                                            required: true,
                                            message: t('messages.aml.file.manager.folder.name.rule'),
                                        },
                                        {
                                            validator: (_, value) => {
                                                if (value && value.trim() === itemToRename?.name.trim()) {
                                                    return Promise.reject(new Error(t('messages.aml.file.manager.rename.same.name.rule')));
                                                }
                                                return Promise.resolve();

                                            },
                                        },
                                        itemToRename?.isDirectory
                                            ? {
                                                pattern: /^[a-zA-Z0-9_ *!|ñ#$&¿]+$/,
                                                message: t('messages.aml.file.manager.especial.character.rule'),
                                            }
                                            : {
                                                pattern: /^[^\\%'"<>?:/]+$/,
                                                message: t('messages.aml.file.manager.especial.character.rule'),
                                            },
                                    ],
                                })(
                                    <Input
                                        className="rename-name-input"
                                        placeholder={itemToRename?.name}
                                        onChange={handleValidateInput}
                                        onKeyUp={handleValidateInput}
                                    />
                                )}
                            </Form.Item>

                            <div className="ant-modal-footer">
                                <div>
                                    <Button className="ant-btn" onClick={() => setIsRenameModalOpen(false)}>
                                        <span>{t('messages.aml.cancel')}</span>
                                    </Button>

                                    <Button
                                        onClick={handleSubmit}
                                        className="ant-btn btn-save-folder"
                                        type="primary"
                                        disabled={isSubmitDisabled}
                                    >
                                        <span>{t('messages.aml.save')}</span>
                                    </Button>
                                </div>
                            </div>
                        </Form>
                    </Spin>
                </Modal>
            )}
        </div>
    );
};

export default Form.create()(RenameItemModal);
